// Light/dark theme control. Dark is the default (bare :root); light is opt-in
// via data-theme="light" on <html>. Choice is persisted and broadcast so the
// Leaflet maps can swap their basemap tiles live.
const KEY = 'siteiq-theme';

const DARK_TILES = 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png';
const LIGHT_TILES = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';

export function getTheme() {
  return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
}

export function setTheme(theme) {
  const t = theme === 'light' ? 'light' : 'dark';
  if (t === 'light') document.documentElement.setAttribute('data-theme', 'light');
  else document.documentElement.removeAttribute('data-theme');
  try { localStorage.setItem(KEY, t); } catch (e) { /* private mode */ }
  window.dispatchEvent(new CustomEvent('themechange', { detail: t }));
}

export function toggleTheme() {
  setTheme(getTheme() === 'light' ? 'dark' : 'light');
}

// Apply the saved choice before first paint (call from the app entry point).
export function applyStoredTheme() {
  try {
    if (localStorage.getItem(KEY) === 'light') {
      document.documentElement.setAttribute('data-theme', 'light');
    }
  } catch (e) { /* ignore */ }
}

export function tileUrl(theme = getTheme()) {
  return theme === 'light' ? LIGHT_TILES : DARK_TILES;
}

// The overlay colour that dims out-of-coverage areas on the map, per theme.
export function maskFill(theme = getTheme()) {
  return theme === 'light'
    ? { color: 'none', fillColor: '#1c1a17', fillOpacity: 0.06 }
    : { color: 'none', fillColor: '#000', fillOpacity: 0.5 };
}
